import { type Dispatch } from 'react';
import { match } from 'ts-pattern';

import { type Money } from '../../../shared/price';
import {
    trackCountDropdownClicked,
    trackDropdownSelection,
} from '../../components/AppointmentSelector/AppointmentSelector.tracking';
import { dispatchEvent } from '../../helper/EventUtils';
import { type BuyboxReducerAction } from '../../types/buyboxReducerTypes';
import { type ClusterType } from '../../types/enums/clusterType';
import { type PurchaseType } from '../../types/enums/purchaseType';
import { BuyboxReducerActionType } from '../../types/enums/reducer/buyboxReducerAction';

const dispatchPurchaseType = (
    dispatch: Dispatch<BuyboxReducerAction>,
    value: PurchaseType,
): void => {
    dispatch({
        type: BuyboxReducerActionType.PurchaseType,
        value: { purchaseType: value },
    });
    dispatchEvent('', { purchaseType: value });
};

const dispatchClusterType = (dispatch: Dispatch<BuyboxReducerAction>, value: ClusterType): void => {
    dispatch({
        type: BuyboxReducerActionType.ClusterType,
        value: { clusterType: value },
    });
    dispatchEvent('', { clusterType: value });
};

const dispatchSeatCountChange = async (
    dispatch: Dispatch<BuyboxReducerAction>,
    selectedSeatCount: string,
    title: string,
    seatCount?: string,
    trackSelection = false,
): Promise<void> => {
    dispatch({
        type: BuyboxReducerActionType.SeatCount,
        value: { seatCount: selectedSeatCount },
    });

    if (trackSelection) {
        if (seatCount || Number(selectedSeatCount) > 1) {
            await trackDropdownSelection(title, Number(selectedSeatCount) - Number(seatCount || 1));
        }
    } else {
        trackCountDropdownClicked();
    }
};

const dispatchResetErrors = (dispatch: Dispatch<BuyboxReducerAction>): void => {
    dispatch({ type: BuyboxReducerActionType.ResetErrors });
};

const dispatchValueVoucherPriceChange = (
    dispatch: Dispatch<BuyboxReducerAction>,
    valueVoucherPrice: Money,
): void => {
    dispatch({
        type: BuyboxReducerActionType.ValueVoucherPriceChange,
        value: { valueVoucherPrice },
    });
};

const handleErrorByCode = (dispatch: Dispatch<BuyboxReducerAction>, errorCode?: number): void => {
    match(errorCode)
        .with(102, () => {
            dispatch({ type: BuyboxReducerActionType.MixedShoppingCartError });
        })
        .with(1_101, () => {
            dispatch({ type: BuyboxReducerActionType.AddingMultipleItemsNotAllowedError });
        })
        .otherwise(() => {
            dispatch({ type: BuyboxReducerActionType.AddToCartError });
        });
};

export {
    dispatchClusterType,
    dispatchPurchaseType,
    dispatchResetErrors,
    dispatchSeatCountChange,
    dispatchValueVoucherPriceChange,
    handleErrorByCode,
};
